import React from "react";
import "./texttoolbar.css";

class TextToolbar extends React.Component {

    constructor(props) {
        super(props);
    }


    // --------------------------------------------------
    // Choix de la couleur
    // --------------------------------------------------

    handleColorClick = (color) => {

        const colorsname = [
            "BLUE",
            "GREEN",
            "CYAN",
            "RED", // rouge
            "MAGENTA", // violet
            "YELLOW", // jaune
            "WHITE"  // gris
        ];



        if (this.props.onClickOnBottomToolsBar) {
            this.props.onClickOnBottomToolsBar({type:"color", value:colorsname[color]});
        }
    };


    // --------------------------------------------------
    // Choix de l'alignement
    // --------------------------------------------------

    handleAlignClick = (align) => {


        if (this.props.onClickOnBottomToolsBar) {
            this.props.onClickOnBottomToolsBar({type:"align", value:align});
        }
    };


    render() {

        const colors = [
            "#2878d0", // bleu
            "#6fa33b", // vert
            "#13a4a5", // turquoise
            "#e33b3b", // rouge
            "#a33bc1", // violet
            "#c8aa32", // jaune
            "#b8b8b8"  // gris
        ];


        return (

            <div className="text-toolbar">


                {/* =====================================
                    COULEURS
                    ===================================== */}

                <div className="toolbar-colors">

                    {colors.map((color,index) => (

                        <button
                            key={color}
                            className={
                                "color-button " 
                            }
                            style={{
                                "--button-color": color
                            }}
                            onClick={() => {
                                this.handleColorClick(index);
                            }}
                        >

                            <span />

                        </button>

                    ))}

                </div>


                {/* =====================================
                    ALIGNEMENTS
                    ===================================== */}

                <div className="toolbar-align">


                    {/* ---------------------------------
                        ALIGNEMENT GAUCHE
                        --------------------------------- */}

                    <button
                        className={
                            "align-button " 
                        }
                        onClick={() => {
                            this.handleAlignClick("MOVESUBTITLETOLEFT");
                        }}
                    >

                        <span className="align-icon align-left">

                            <i />
                            <i />
                            <i />
                            <i />

                        </span>

                    </button>


                    {/* ---------------------------------
                        ALIGNEMENT CENTRE
                        --------------------------------- */}

                    <button
                        className={
                            "align-button "
                        }
                        onClick={() => {
                            this.handleAlignClick("MOVESUBTITLETOCENTER");
                        }}
                    >

                        <span className="align-icon align-center">

                            <i />
                            <i />
                            <i />
                            <i />

                        </span>

                    </button>


                    {/* ---------------------------------
                        ALIGNEMENT DROITE
                        --------------------------------- */}

                    <button
                        className={
                            "align-button "
                        }
                        onClick={() => {
                            this.handleAlignClick("MOVESUBTITLETORIGHT");
                        }}
                    >

                        <span className="align-icon align-right">

                            <i />
                            <i />
                            <i />
                            <i />

                        </span>

                    </button>


                </div>

            </div>
        );
    }
}

export default TextToolbar;